import React, { useRef, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaDownload } from 'react-icons/fa';
import { PageHero, PageHeroInner, PageWrap, PageInner } from '../components/PageHero';
import audioFile1 from '../assets/audio/testiAudio1.m4a';
import audioFile2 from '../assets/audio/testiAudio2.m4a';
import audioFile3 from '../assets/audio/testiAudio3.m4a';
import audioFile4 from '../assets/audio/testiAudio4.m4a';
import audioFile5 from '../assets/audio/testiAudio5.m4a';
import audioFile6 from '../assets/audio/testiAudio6.m4a';
import audioFile7 from '../assets/audio/testiAudio7.m4a';
import audioFile8 from '../assets/audio/testiAudio8.m4a';
import audioFile9 from '../assets/audio/testiAudio9.m4a';
import audioFile10 from '../assets/audio/testiAudio10.m4a';
import audioFile11 from '../assets/audio/testiAudio11.m4a';
import audioFile12 from '../assets/audio/testiAudio12.m4a';
import audioFile13 from '../assets/audio/testiAudio13.m4a';
import audioFile14 from '../assets/audio/testiAudio14.m4a';
import audioFile15 from '../assets/audio/testiAudio15.m4a';
import audioFile16 from '../assets/audio/testiAudio16.m4a';
import audioFile17 from '../assets/audio/testiAudio17.m4a';
import audioFile18 from '../assets/audio/testiAudio18.m4a';
import audioFile19 from '../assets/audio/testiAudio19.m4a';
import audioFile20 from '../assets/audio/testiAudio20.m4a';
import audioFile21 from '../assets/audio/testiAudio21.m4a';
import audioFile22 from '../assets/audio/testiAudio22.m4a';
import audioFile23 from '../assets/audio/testiAudio23.m4a';
import audioFile24 from '../assets/audio/testiAudio24.m4a';
import audioFile25 from '../assets/audio/testiAudio25.m4a';
import audioFile26 from '../assets/audio/testiAudio26.m4a';
import audioFile27 from '../assets/audio/testiAudio27.m4a';
import audioFile28 from '../assets/audio/testiAudio28.m4a';
import audioFile29 from '../assets/audio/testiAudio29.m4a';
import audioFile30 from '../assets/audio/testiAudio30.m4a';
import audioFile31 from '../assets/audio/testiAudio31.m4a';
import audioFile32 from '../assets/audio/testiAudio32.m4a';
import audioFile33 from '../assets/audio/testiAudio33.m4a';
import audioFile34 from '../assets/audio/testiAudio34.m4a';
import audioFile35 from '../assets/audio/testiAudio35.m4a';
import audioFile36 from '../assets/audio/testiAudio36.m4a';
import audioFile37 from '../assets/audio/testiAudio37.m4a';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

// ── VIDEO ──────────────────────────────────────────────────
const VideoSection = styled.div`
  background: white;
  border: 1px solid #eee;
  margin-bottom: 2px;
`;

const VideoWrap = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: 0;
  }
`;

const VideoCaption = styled.div`
  padding: 1.8rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 3px solid #03045e;

  p {
    color: #555;
    font-size: 0.95rem;
    line-height: 1.8;
    max-width: 700px;
  }

  span {
    font-size: 4rem;
    font-weight: 900;
    color: #f0f0f0;
    letter-spacing: -3px;
    flex-shrink: 0;
    margin-left: 2rem;
  }
`;

// ── STATS ROW ──────────────────────────────────────────────
const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
  background: #eee;
  margin-bottom: 2px;

  @media (max-width: 600px) { grid-template-columns: 1fr; }
`;

const StatBox = styled.div`
  background: #03045e;
  padding: 2.5rem;
  text-align: center;
  transition: background 0.25s ease;

  &:hover { background: #00b4d8; h3, p { color: #03045e; } }

  h3 {
    font-size: clamp(2rem, 3vw, 2.8rem);
    font-weight: 900;
    color: #00b4d8;
    letter-spacing: -2px;
    line-height: 1;
    transition: color 0.25s ease;
  }

  p {
    color: rgba(255,255,255,0.5);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-top: 0.5rem;
    transition: color 0.25s ease;
  }
`;

// ── PRICE ──────────────────────────────────────────────────
const PriceSection = styled.div`
  background: white;
  border: 1px solid #eee;
  margin-bottom: 2px;
  animation: ${fadeUp} 0.6s ease-out;
`;

const SectionHeader = styled.div`
  padding: 2rem 2.5rem;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 1.5rem;

  span {
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: #00b4d8;
  }

  h2 {
    font-size: 1.3rem;
    font-weight: 900;
    color: #03045e;
    letter-spacing: -0.5px;
  }

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #f0f0f0;
  }
`;

const PriceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: #f0f0f0;

  @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`;

const PriceCard = styled.div`
  background: white;
  padding: 2rem;
  transition: all 0.25s ease;
  cursor: default;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0;
    width: 0; height: 2px;
    background: #00b4d8;
    transition: width 0.3s ease;
  }

  &:hover {
    background: #f8faff;
    &::after { width: 100%; }
  }

  span {
    display: block;
    font-size: 0.75rem;
    color: #aaa;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.6rem;
  }

  strong {
    display: block;
    font-size: 1.3rem;
    font-weight: 900;
    color: #03045e;
    letter-spacing: -0.5px;
  }
`;

// ── ORDER ──────────────────────────────────────────────────
const OrderSection = styled.div`
  background: #03045e;
  border: 1px solid #03045e;
  margin-bottom: 2px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: #03045e;

  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const OrderBox = styled.div`
  background: #03045e;
  padding: 3rem 2.5rem;

  h3 {
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: #00b4d8;
    margin-bottom: 1.5rem;
  }

  p {
    color: rgba(255,255,255,0.6);
    font-size: 0.95rem;
    line-height: 1.9;
  }

  strong { color: #ffffff; }
`;

const BonusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  background: #00b4d8;
  color: #03045e;
  padding: 0.8rem 1.5rem;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  margin-top: 1.5rem;
`;

// ── DOWNLOAD ───────────────────────────────────────────────
const DownloadSection = styled.div`
  background: #03045e;
  border: 1px solid #03045e;
  margin-top: 2px;
  padding: 3rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;

  @media (max-width: 768px) { flex-direction: column; text-align: center; }

  div {
    h3 {
      font-size: 0.72rem;
      font-weight: 800;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #00b4d8;
      margin-bottom: 0.8rem;
    }
    p {
      color: rgba(255,255,255,0.55);
      font-size: 0.95rem;
      line-height: 1.7;
    }
  }
`;

const DownloadBtn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  background: #00b4d8;
  color: #03045e;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.25s ease;

  &:hover { background: #90e0ef; }
`;

// ── TESTIMONIALS ───────────────────────────────────────────
const TestiSection = styled.div`
  background: white;
  border: 1px solid #eee;
`;

const AudioGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1px;
  background: #f0f0f0;
`;

const AudioItem = styled.div`
  background: ${p => p.active ? '#03045e' : 'white'};
  padding: 1.5rem;
  position: relative;
  cursor: pointer;
  transition: background 0.25s ease;

  &:hover {
    background: #03045e;
    .label { color: #00b4d8; }
    .num { color: rgba(255,255,255,0.08); }
  }

  .num {
    font-size: 2rem;
    font-weight: 900;
    color: ${p => p.active ? 'rgba(255,255,255,0.08)' : '#f0f0f0'};
    letter-spacing: -2px;
    line-height: 1;
    transition: color 0.25s ease;
  }

  .label {
    font-size: 0.7rem;
    color: ${p => p.active ? '#00b4d8' : '#aaa'};
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-top: 0.3rem;
    transition: color 0.25s ease;
  }

  audio {
    width: 100%;
    height: 32px;
    opacity: ${p => p.active ? 1 : 0};
    max-height: ${p => p.active ? '40px' : '0'};
    overflow: hidden;
    transition: all 0.3s ease;
    display: block;
    margin-top: ${p => p.active ? '0.8rem' : '0'};
  }
`;

const AudioPlayer = ({ audioFiles }) => {
  const audioRefs = useRef([]);
  const [activeIdx, setActiveIdx] = React.useState(null);

  useEffect(() => { audioRefs.current = audioRefs.current.slice(0, audioFiles.length); }, [audioFiles]);

  const handlePlay = (idx) => {
    setActiveIdx(idx);
    audioRefs.current.forEach((ref, i) => { if (i !== idx && ref && !ref.paused) ref.pause(); });
  };

  const handlePause = (idx) => {
    if (activeIdx === idx) setActiveIdx(null);
  };

  return (
    <AudioGrid>
      {audioFiles.map((file, i) => (
        <AudioItem key={i} active={activeIdx === i} onClick={() => setActiveIdx(i)}>
          <div className="num">{String(i + 1).padStart(2, '0')}</div>
          <div className="label">Testimoni</div>
          <audio
            controls
            ref={el => audioRefs.current[i] = el}
            onPlay={() => handlePlay(i)}
            onPause={() => handlePause(i)}
            onEnded={() => handlePause(i)}
          >
            <source src={file} type="audio/mp4" />
          </audio>
        </AudioItem>
      ))}
    </AudioGrid>
  );
};

export default function FuelWaterHybrid() {
  const audioFiles = [
    // Terbaru (21-37)
    audioFile37, audioFile36, audioFile35, audioFile34, audioFile33,
    audioFile32, audioFile31, audioFile30, audioFile29, audioFile28,
    audioFile27, audioFile26, audioFile25, audioFile24, audioFile23,
    audioFile22, audioFile21,
    // Lama (1-20)
    audioFile20, audioFile19, audioFile18, audioFile17, audioFile16,
    audioFile15, audioFile14, audioFile13, audioFile12, audioFile11,
    audioFile10, audioFile9, audioFile8, audioFile7, audioFile6,
    audioFile5, audioFile4, audioFile3, audioFile2, audioFile1,
  ];

  return (
    <>
      <PageHero data-title="FWH">
        <PageHeroInner>
          <div className="left">
            <span>Hidrogen untuk Bahan Bakar</span>
            <h1>FUEL WATER<br />HYBRID</h1>
            <p>Sistem hybrid air-bahan bakar. Hemat BBM minimal 30%, potensi efisiensi hingga 70%</p>
          </div>
          <div className="right">
            <div className="data-title">FWH</div>
          </div>
        </PageHeroInner>
      </PageHero>

      <PageWrap style={{ padding: '3rem 4rem' }}>
        <PageInner style={{ maxWidth: '1100px' }}>

          {/* VIDEO */}
          <VideoSection>
            <VideoWrap>
              <iframe
                title="Fuel Water Hybrid"
                src="https://www.youtube.com/embed/KvY8W8gJgYM"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen loading="lazy"
              />
            </VideoWrap>
            <VideoCaption>
              <p>
                Sebuah alat reaktor yang mengubah <strong>AIR menjadi GAS HIDROGEN OKTAN 130</strong> hingga
                power bertambah 2× & BBM hemat lebih dari 30%. Asap buangan menjadi <strong>nol</strong> (tanpa emisi carbon).
                Terpasang di belakang kendaraan bensin/solar tanpa mengubah atau mengintervensi mesin.
                Dapat diterapkan mulai dari kendaraan bermesin kecil hingga kendaraan sangat besar.
              </p>
              <span>01</span>
            </VideoCaption>
          </VideoSection>

          {/* STATS */}
          <StatsRow>
            <StatBox><h3>130</h3><p>Oktan Bahan Bakar</p></StatBox>
            <StatBox><h3>30–70%</h3><p>Hemat BBM</p></StatBox>
            <StatBox><h3>0</h3><p>Emisi Gas Buang</p></StatBox>
          </StatsRow>

          {/* PRICE */}
          <PriceSection>
            <SectionHeader>
              <span>Investasi</span>
              <h2>Daftar Harga</h2>
            </SectionHeader>
            <PriceGrid>
              {[
                { label: 'Motor 100–250 CC',                    price: 'Rp 3,5 Juta'  },
                { label: 'Mobil 1.000–2.500 CC',               price: 'Rp 10,5 Juta' },
                { label: 'Mobil 3.000 CC (Turbo)',              price: 'Rp 18,5 Juta' },
                { label: 'Mobil 3.000–5.000 CC',               price: 'Rp 18 Juta'   },
                { label: 'Alat Berat',                          price: 'Rp 35 Juta'   },
                { label: 'Multi',                               price: 'Rp 12,5 Juta' },
                { label: 'Generator Besar / Tronton / Kapal Laut', price: 'Mulai Rp 45 Juta' },
              ].map((item, i) => (
                <PriceCard key={i}>
                  <span>{item.label}</span>
                  <strong>{item.price}</strong>
                </PriceCard>
              ))}
            </PriceGrid>
          </PriceSection>

          {/* ORDER */}
          <OrderSection>
            <OrderBox>
              <h3>Konsep Hybrid</h3>
              <p>
                Walaupun teknologi kami secara teknis mampu <strong>menggantikan bahan bakar 100% dengan air</strong>,
                fokus utama saat ini adalah sistem Hybrid untuk memastikan keandalan dan kenyamanan pengguna.
                Efisiensi dapat mencapai <strong>70%</strong> tergantung karakter dan cara pengoperasian
                kendaraan oleh operator/pengemudi.
              </p>
            </OrderBox>
            <OrderBox>
              <h3>Proses Pemesanan</h3>
              <p>
                Pembuatan alat reaktor dengan <strong>DP 50%</strong>, lunas saat akan dipasang.
                Proses pabrikasi <strong>10 hari kerja</strong>, instalasi pemasangan <strong>1 jam</strong> —
                biaya sudah termasuk pemasangan.
              </p>
              <BonusBadge>🎁 Bantu Jual 20 Unit → GRATIS 1 Unit</BonusBadge>
              <p style={{ marginTop: '1.5rem' }}>
                Info lengkap: <strong style={{ color: '#00b4d8', fontSize: '1.1rem' }}>08128888845</strong>
              </p>
            </OrderBox>
          </OrderSection>

          {/* TESTIMONIALS */}
          <TestiSection>
            <SectionHeader>
              <span>Suara Pengguna</span>
              <h2>Testimoni</h2>
            </SectionHeader>
            <AudioPlayer audioFiles={audioFiles} />
          </TestiSection>

          {/* DOWNLOAD */}
          <DownloadSection>
            <div>
              <h3>Unduh Brosur</h3>
              <p>Dapatkan informasi lengkap mengenai teknologi Hidrogen.id dalam format PDF.</p>
            </div>
            <DownloadBtn href="/assets/media/HIDROGEN.id.pdf" download="HIDROGEN.id.pdf">
              <FaDownload size={14} /> Download Hidrogen
            </DownloadBtn>
          </DownloadSection>

        </PageInner>
      </PageWrap>
    </>
  );
}
